import { GENDER_FEMALE } from '../common/GenderOptions';

const round = number => {
	return Math.round(number * 100) / 100;
};

export default ({ weight, height, age, gender }) => {
	let kcal = 0,
		kjKoef = 4.185;

	if (weight > 0 && height > 0 && age > 0) {
		if (gender === GENDER_FEMALE) {
			kcal = 655.0955 + 9.5634 * weight + 1.8496 * height - 4.6756 * age;
		} else {
			kcal = 66.473 + 13.7516 * weight + 5.0033 * height - 6.755 * age;
		}
	}

	return {
		kcal: round(kcal),
		kj: round(kjKoef * kcal),
	};
};
